export const env = process.env as {
  REACT_APP_DEPLOYMENT_SETS?: string
  REACT_APP_ENABLE_DEV_GUI?: string
  REACT_APP_HOST_ENV?: string
  REACT_APP_GTM_ID?: string
  REACT_APP_TRANSAK_API_KEY?: string
  REACT_APP_ENABLE_SECONDARY_MARKET_C2A?: string
}
